import { render, staticRenderFns } from "./AnaliseDocumentacaoMenuCredenciamento.vue?vue&type=template&id=5190e9e6&scoped=true"
import script from "./AnaliseDocumentacaoMenuCredenciamento.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoMenuCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoMenuCredenciamento.vue?vue&type=style&index=0&id=5190e9e6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190e9e6",
  null
  
)

export default component.exports